// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WfyV","largestCol":"styles_largestCol__1IQKB","smallestCol":"styles_smallestCol__2KhX1"};